/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuremove1Inputs */

const en_menuremove1 = /** @type {(inputs: Menuremove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_menuremove1 = /** @type {(inputs: Menuremove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Menuremove1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuremove1 = /** @type {((inputs?: Menuremove1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuremove1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuremove1(inputs)
	return de_menuremove1(inputs)
});
export { menuremove1 as "menuRemove" }